import axios from '../axios'

// 获取appid
export const getWxConfig = (data) => {
  return axios({
    url: '/applet/junior/getWxconfig',
    method: 'GET',
    data
  })
}
// 获取用户是否登录
export const getWxCheck = (data) => {
  return axios({
    url: '/applet/junior/check',
    method: 'GET',
    data
  })
}
// 获取用户嘻嘻
export const getUserInfo = (data) => {
  return axios({
    url: '/applet/junior/getUserInfo',
    method: 'GET',
    data
  })
}
// 思维活动页首页
export const getPushedList = (data) => {
  return axios({
    url: '/wechat/mind_camp/pushed/list',
    method: 'GET',
    data
  })
}

// 去报名
export const goEnroll = (data) => {
  return axios({
    url: '/wechat/mind_camp/enroll',
    method: 'POST',
    data
  })
}
//通过大活动获取小活动列表
export const getPushedChildList = (data) => {
  return axios({
    url: '/applet/mind_camp/pushed/child_list',
    method: 'GET',
    data
  })
}

//学生获取成长脚印
export const getindCampHistory = (data) => {
  return axios({
    url: '/wechat/mind_camp/history',
    method: 'GET',
    data
  })
}
// 生成urlLink
export const getUrlLink = (data) => {
  return axios({
    url: '/applet/micro/getUrlLink',
    method: 'POST',
    data
  })
}
// 获取海报
export const getPoster = (data) => {
  return axios({
    url: '/zyc/mind_camp_playbill/get',
    method: 'GET',
    data
  })
}


// WEBPACK FOOTER //
// ./src/http/moudules/home.js